import FormInputTypes from '../components/atoms/formEnums/formInputTypes';
import viewRelatedDevices from './viewRelatedDevice';

export default {
  title: 'Data',
  parentId: 'mainHubConfigId',
  isExpand: true,
  attributeName: 'configData',
  isObjectWrapper: true,
  default: {
    minBuildNumber: 1
  },
  fields: [
    {
      attributeName: 'mainHubId',
      helpText: 'mainHubId',
      type: FormInputTypes.TEXT_INPUT.NUMBER,
      label: 'mainHubId',
      placeholder: 'mainHubId...',
      hidden: true,
    },
    {
      attributeName: 'minBuildNumber',
      helpText: 'Build number',
      type: FormInputTypes.TEXT_INPUT.NUMBER,
      label: 'minBuildNumber',
      placeholder: 'minBuildNumber...',
    },
    {
      attributeName: 'appEnviroment',
      helpText: 'App Platform',
      type: FormInputTypes.SELECT,
      label: 'App Platform',
      placeholder: 'platform...',
      multiple: true,
      options: [
        { name: '', value: '' },
        { name: 'App Android XR', value: 'app-androidxr'},
        { name: 'App iOS', value: 'app-ios'},
        { name: 'App Unity', value: 'app-unity'},  
        { name: 'App Unity Oculus', value: 'app-unity-oculus'},   
        { name: 'App Unity Android', value: 'app-unity-android'},   
        { name: 'App Unity Pico', value: 'app-unity-pico'},
        { name: 'App Vision', value: 'app-vision'},
        { name: 'App Web', value: 'app-web'},
        { name: 'Mobile Android', value: 'mobile-android'},
        { name: 'SDK Android', value: 'sdk-android'},
        { name: 'SDK Android XR', value: 'sdk-androidxr'},
        { name: 'SDK Apple', value: 'sdk-apple'},
        { name: 'SDK iOS', value: 'sdk-ios'},
        { name: 'SDK Unity', value: 'sdk-unity'},
        { name: 'SDK Vision', value: 'sdk-vision'}, 
        { name: 'SDK Web', value: 'sdk-web'}, 
      ],
      visibleWhen:[{"field":"mainHubId","notValue":"1"}] //not visible when mainhub is XTADIUM
    },
    {
      attributeName: 'devices',
      label: 'Devices',
      type: FormInputTypes.RELATIONSHIP,
      canEdit: true,
      canCreate: true,
      canFilter: false,
      configFile: viewRelatedDevices,
      popupSize:'xl',
      helpText: 'Select one or more registered devices. Device IDs will be stored automatically.',
    },
    {
      attributeName: 'countryCode',
      helpText: 'List of Country Codes',
      type: FormInputTypes.SELECT,
      label: 'Country Code',
      placeholder: 'Please enter to add Country code...',
      multiple: true,
      url: 'countries',
      filter:'name',
      asyncSelect: true,
      options: [],
    },
    {
      attributeName: 'languageCode',
      helpText: 'List of Language Codes',
      type: FormInputTypes.SELECT,
      label: 'Language Code',
      options: [
        {name:"Spanish", value:"es"},
        {name:"English", value:"en"},
        {name:"English-UK", value:"en-GB"},
        {name:"English-US", value:"en-US"},
        {name:"Spanish-ES", value:"es-ES"},
        {name:"German-DE", value:"de-DE"},
      ],
      emptyValue:true,
      default:'(Empty)', //default value to empty option
    },
    {
      attributeName: 'regionCode',
      helpText: 'List of Region Codes',
      type: FormInputTypes.SELECT,
      label: 'Region Code',
      placeholder: 'Please enter to add Region code...',
      multiple: true,
      url: 'regions',
      filter:'name',
      asyncSelect: true,
      options: [],
    },
    {
      attributeName: 'IP',
      helpText: 'List of IPs',
      type: FormInputTypes.TEXT_INPUT.TEXT,
      label: 'IP',
      multiple:true,
      placeholder: 'Press enter to add IP...',
    },
    {
      attributeName: 'oculusUser',
      helpText: 'List of Oculus Users',
      type: FormInputTypes.TEXT_INPUT.TEXT,
      label: 'Oculus User',
      multiple:true,
      placeholder: 'Press enter to add Oculus User...',
      visibleWhen:[{"field":"mainHubId","notValue":"1"}] //not visible when mainhub is XTADIUM
    },
    {
      attributeName: 'comment',
      helpText: 'Comment to identify this group od config data',
      type: FormInputTypes.TEXT_INPUT.TEXT,
      label: 'Comment',
      placeholder: 'Press enter to add Comment...',
    },
  ],
};
